import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { FC } from 'react';

const iconButtonStyle = {
  position: 'absolute',
  right: 18,
  top: 18,
  width: 34,
  height: 34,
  color: '#64748b',
  border: '1px solid #e2e8f0',
  borderRadius: 2,
};

interface DialogModalProp extends React.PropsWithChildren {
  onClose: () => void;
  open: boolean;
  title?: string;
  style?: React.CSSProperties;
  width?: number | string;
}

export const DialogModal: FC<DialogModalProp> = ({
  open,
  onClose,
  title,
  children,
  style = {},
  width = 450,
}) => {
  const defaultStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: `min(${
      typeof width === 'number' ? `${width}px` : width
    }, calc(100vw - 32px))`,
    bgcolor: 'background.paper',
    p: 3,
    border: '1px solid #e2e8f0',
    borderRadius: 3,
    boxShadow: '0 24px 64px rgba(15, 23, 42, 0.22)',
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 48px)',
    outline: 'none',
    '& .MuiInputBase-root': {
      borderRadius: 2,
    },
    '& .MuiButton-root': {
      minHeight: 40,
      borderRadius: 2,
      textTransform: 'none',
      fontWeight: 700,
    },
    '& .MuiButton-containedPrimary': {
      backgroundColor: '#0b8fca',
      '&:hover': { backgroundColor: '#087caf' },
    },
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(4px)',
            backgroundColor: 'rgba(15, 23, 42, 0.48)',
          },
        },
      }}
    >
      <Box sx={[defaultStyle, style]}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: 36,
            pr: 5,
            pb: title ? 2 : 0,
            mb: title ? 0.5 : 0,
            borderBottom: title ? '1px solid #eef2f7' : 'none',
          }}
        >
          {title && (
            <Box
              component="h2"
              sx={{
                m: 0,
                color: '#0f172a',
                fontSize: 21,
                fontWeight: 700,
                lineHeight: 1.3,
              }}
            >
              {title}
            </Box>
          )}
          <IconButton aria-label="close" onClick={onClose} sx={iconButtonStyle}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        {children}
      </Box>
    </Modal>
  );
};
